import React, {useEffect, useState, Fragment, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import {Button} from 'react-bootstrap';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSectionNew';
import ModalPop from 'components/sales/modal/modal';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import {Link} from 'react-router-dom';
import useLatLng from 'hooks/uselatlng/uselatlng';
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import {shouldShowSiteCheckinModal, shouldShowCheckoutButton} from 'services/attendance/isActiveDistanceCheckin';
import {
  checkoutErrorMessage,
  getSiteLatLng,
  isCheckoutApiSuccess,
  resolveDistanceRowId,
} from 'services/attendance/siteCheckout';
import {toast} from "react-toastify";
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const PmProjectSitesCheckList = ({
  match,
  fetchgetSiteGates,
  pmGateData,
  history,
  sendForApproval,
  getScheduledTicket,
  scheduledTickets,
  getCheckLocation,
  locationCheck,
  siteEnableDisable,
  getSiteState,
  getSiteData,
  siteData,
  calculateDistance,
  engDistanceData,
  getDistanceData,
  distanceDetails,
  generateHappyCodePM,
  fetchPmProjectChecklist,
  pmProjectChecklist=[],
  activeDistanceCheckin,
  refreshAfterSiteCheckout,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [listData, setlistData] = useState({});
  const islatlng = useLatLng();
  const [modalNote, setModalNote] = useState(false);
  const [islocationValid, setisLocationValid] = useState(0);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isNotMatchModal, setNotMatchModal] = useState(false);
  const [isModalLocation, setIsModalLocation] = useState(false);
  const [isAllFieldDisable, setAllFieldDisable] = useState(false)
  const [StatusMsg, setStatusMsg] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [distanceReady, setDistanceReady] = useState(false);
  const [role, setRole] = useState('');
  const [otp, setOtp] = useState('');
  const [modalOtp, setModalOtp] = useState(false);
  const [otpMsg, setMessage] = useState('');

  const handleModalHideLocation = () => setIsModalLocation(false);
  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    setAllFieldDisable(false)
    if (fetchPmProjectChecklist !== null && match.params.manageId)
      (async () => {
        setIsLoading(true);
        // await fetchgetSiteGates(match.params.manageId);
        await fetchPmProjectChecklist(match.params.id,match.params.manageId)
        await getCheckLocation(match.params.id, islatlng?.lat, islatlng?.lng);
        await getScheduledTicket(match.params.id, match.params.manageId);
        await getSiteState(match.params.id)
        setIsLoading(false);
      })();
  }, [fetchPmProjectChecklist, islatlng]);

    useEffect(() => {
        let roles = JSON.parse(localStorage.getItem('roles'))
        setRole(roles[0]?.id)
    }, [])

    useEffect( () => {
        let cancelled = false;
        (async () => {
            try {
              await getDistanceData(match.params.id, 'PM', match.params.manageId)
            } finally {
              if (!cancelled) {
                setDistanceReady(true);
              }
            }
        })()
        return () => { cancelled = true; };
    }, [match.params.id, match.params.manageId])

    useEffect(() => {
      if (match.params.id && getSiteData) {
        getSiteData(match.params.id);
      }
    }, [match.params.id])

    useEffect( () => {
        if (!distanceReady) return;
        setIsOpen(
          shouldShowSiteCheckinModal({
            distanceDetails,
            activeCheckin: activeDistanceCheckin,
            siteId: match.params.id,
            moduleType: 'PM',
          })
        );
    }, [distanceDetails, distanceReady, activeDistanceCheckin, match.params.id])

    useEffect(() => {
        if (fetchgetSiteGates !== null && match.params.manageId)
            (async () => {
                setIsLoading(true);
                await fetchgetSiteGates(match.params.manageId);
                await getCheckLocation(match.params.id, islatlng?.lat, islatlng?.lng);
                await getScheduledTicket(match.params.id, match.params.manageId);
                await getSiteState(match.params.id)
                setIsLoading(false);
            })();
    }, [fetchgetSiteGates, islatlng]);

  useEffect(() => {
    if (pmGateData && pmGateData.result && pmGateData?.result?.site_data) {
      // setlistData(pmGateData.result);
      setisLocationValid(
        pmGateData.result && pmGateData.result.is_location_validate
      );

      if(pmGateData?.result?.site_data['site_status'] === 16 ){
        setAllFieldDisable(true)
      }
    }

  }, [pmGateData]);


    useEffect( () => {
        if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
         if(engDistanceData?.alreadyCheckIn == true) {
             toast.warning(engDistanceData?.message);
             history.push(`${baseUrl}/pm-projects`);
             setTimeout(() => { 
              window.location.reload();
            },5000);
        } else {
            toast.success('Distance is successfully fetched');
            window.location.reload();
            setIsOpen(false);
            Object.keys(engDistanceData).forEach(key => {
                delete engDistanceData[key];
            })
         }
        }else if(engDistanceData === null){
            toast.success('Distance is not fetched');
            setIsOpen(true);
        }
    }, [engDistanceData])

    const goToCardDetails = (site_id,schedule_id,id) => {
        if (islocationValid) {
            if (locationCheck?.status === 2) {
                history.push({
                    pathname: `/dashboard/pm-checklist-ques/${site_id}/${match.params.manageId}/${id}`,
                    state: {gateId: id},
                });
            } else if (locationCheck?.status === 1) {
                setIsModalLocation(true);
            } else if (locationCheck?.status === 3) {
                isShowModal(true);
            } else if (locationCheck?.status === 0) {
                setNotMatchModal(true);
            }
        } else {
            history.push({
                pathname: `/dashboard/pm-checklist-ques/${site_id}/${schedule_id}/${id}`,
                state: {gateId: id},
            });
        }
    };

    const toRad = (Value) => {
        return Value * Math.PI / 180
      }
    
      const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)
    
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
      }
    const handleCheckOut = async (passedId) => {
        const id = passedId || resolveDistanceRowId(distanceDetails, activeDistanceCheckin);
        if (!id) {
          toast.error('Check-in record not found.');
          return false;
        }
        const checkout_lat = Number(islatlng?.lat);
        const checkout_long = Number(islatlng?.lng);
        if (isNaN(checkout_lat) || isNaN(checkout_long)) {
          alert(localization.locationPermission);
          return false;
        }
        const site = getSiteLatLng(siteData);
        let checkout_distance = 0;
        if (site) {
          checkout_distance = calcCrow(checkout_lat, checkout_long, site.lat, site.lng);
          if (!Number.isFinite(checkout_distance)) {
            toast.error('Distance Not Fetched.');
            return false;
          }
        }
        const payload = {
          id,
          checkout_lat,
          checkout_long,
          checkout_distance_in_km: checkout_distance,
          checkout_remark: '',
        };
        try {
          const res = await axios.post(`${Config.maintenance.rmCheckOut}`, payload);
          if (isCheckoutApiSuccess(res?.data)) {
            toast.success('Checkout Successfully.');
            if (typeof refreshAfterSiteCheckout === 'function') {
              await refreshAfterSiteCheckout(match.params.id, 'PM');
            }
            history.push(`${baseUrl}/pm-projects`);
            return true;
          }
          toast.error(checkoutErrorMessage(res?.data));
        } catch (err) {
          toast.error(checkoutErrorMessage(err?.response?.data));
        }
        return false;
      }

    const handlePmcomplete = async () => { 
      if(otp == '') {
        setMessage('Please enter OTP');
        return false;
      }
      if(otp != '' && otp.length != 6) {
        setMessage('Please enter 6 digit OTP');
        return false;
      }
      if (match.params.id && otp != '') {
        setIsLoading(true);
        const res = await sendForApproval(match.params.manageId,otp);
        setIsLoading(false);
        if (res === true) {
            setIsModal(true);
        }
      }
    }  

    const completeStage = async () => {
        let flag = null;
        pmProjectChecklist && pmProjectChecklist?.result &&
        pmProjectChecklist?.result.map((checkListData, index) => {
          checkListData &&
          checkListData.gates &&
          checkListData.gates.length > 0 &&
          checkListData.gates.map((obj) => {
              if (obj.status !== 'Completed') {
                  setModalNote(true);
                  flag = true;
              }
          });
      })
      if (flag !== true) {
          flag = false;
      }
      if(!flag) {
          setModalOtp(true);
      }
    };
    


  const headerBtns = () => {
    setStatusMsg("")
    if(Object.keys(siteEnableDisable).length > 0 ){
      if(siteEnableDisable.state === "DISABLE"){
        if(siteEnableDisable.status === "REJECTED"){
        }else if(siteEnableDisable.status === "PENDING"){
          setStatusMsg("Disable Pending")
        }else {
          setStatusMsg("Disabled")
        }
      }

      if(siteEnableDisable.state === "ENABLE"){
        if(siteEnableDisable.status === "REJECTED"){
          setAllFieldDisable(true)
        }else if(siteEnableDisable.status === "PENDING"){
          setStatusMsg("Enable Pending")
        }else {
          setStatusMsg("Enabled")
        }
      }
    }
    
    return (
      <Fragment>
        {shouldShowCheckoutButton({
          distanceDetails,
          activeCheckin: activeDistanceCheckin,
          siteId: match.params.id,
          moduleType: 'PM',
        }) ? (
          <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div class="btn-group" role="group">
          <Button
          className=" btn btn-transparent btn-danger"
          onClick={() => handleCheckOut(resolveDistanceRowId(distanceDetails, activeDistanceCheckin))}
        >
          {localization.checkOut}
        </Button>
        </div>
        </div>
        ):''}
        &nbsp;&nbsp;
        <Button
          className="btn btn-primary d-md-inline-block "
          onClick={() => {
            completeStage();
          }}
          disabled={isAllFieldDisable}
        >
          {localization.stageCompleted}
        </Button>
      </Fragment>
    );
  };

  const resendOTP = () => {
    (async () => {
          setIsLoading(true);
          if(match.params.manageId !== undefined ) {
              setMessage('Sending OTP Please wait...');
              const otpStatus = await generateHappyCodePM(match.params.manageId);
              if(otpStatus) {
                   setIsLoading(false);
                   setMessage('OTP Sent');

              }
          }
          setIsLoading(false);
    })()
  }
  
  return (

    <Layout
      title={localization.viewPmList}
      isGoback
      Buttons={headerBtns}
      isLoading={isLoading}
      linkUrl={`${baseUrl}/pm-projects`}
    >

        {role === 9 && isOpen ?
          <div className="popup-box">
            <div className="box"><Link
                to={`${baseUrl}/pm-projects`}
                className="btn btn-primary mb-4"
                style={{'cursor': 'pointer','float':'right','border':'0px','box-shadow':'none !important','position':'relative','top':'-17px'}}
            >
                x
            </Link>

              <DistanceCalculator
                  task_id={match.params.manageId}
                  siteData={siteData}
                  getSiteData={getSiteData}
                  calculateDistance={calculateDistance}
                  siteId={match.params.id}
                  moduleType={"PM"}
                  to={`${baseUrl}/pm-projects`}
              />
            </div>
          </div> :

          <>
      <div className="field-wrapper">
        {/* <div className="col-md-6 col-sm-12 col-xs-12">
          <ConstantInput
              label='Enter 6 digit OTP'
              type="number"
              max={6}
              maxLength={6}
              value={remarkData.otp}
              handleChange={(val) =>
                setRemarkData({ ...remarkData, otp: val })
              }
              required
              isStarRequired={true}
          />
        </div> */}
      </div>    
      <div className="field-wrapper">
      {pmProjectChecklist && pmProjectChecklist?.result &&
                        pmProjectChecklist?.result.map((checkListData, index) => {

                        return (
                          <div key={index} style={{"marginBottom": "35px"}}>
                            {/* Render site data */}
                            {checkListData?.site_data && (
                              <div className="row">
                                <div className="col-md-12 col-xs-12">
                                  <h4 style={{"marginBottom": "15px"}}>
                                    {checkListData.site_data.client_name} (
                                    {checkListData.site_data.site_no}) {StatusMsg}
                                  </h4>
                                </div>
                              </div>
                            )}

                            {/* Render gates */}
                            {checkListData?.gates &&
                              checkListData.gates.map((obj, gateIndex) => (
                                <CardSection title={`Solution ${obj.gate_no}`} key={gateIndex}>
                                  <div className="col-md-12">
                                    <h4 style={{"fontSize": "large"}}>
                                      {obj.gate_name ? obj.gate_name : null}
                                      {obj.gate_amc ? ` (${obj.gate_amc})` : null}
                                    </h4>
                                  </div>
                                  <Button
                                  style={{"marginTop": "25px","marginLeft": "15px"}}
                                    className={
                                      obj.status === "Completed"
                                        ? "url-card card-success"
                                        : "url-card card-danger"
                                    }
                                    onClick={() => {
                                      goToCardDetails(checkListData.site_data.id,obj.schedule_id,obj.gate_id);
                                    }}
                                  >
                                    {obj.checklist_name}
                                  </Button>
                                </CardSection>
                              ))}
                          </div>
                        );
                      })}
                    </div>
                    {scheduledTickets &&
                        scheduledTickets.gates &&
                        scheduledTickets.gates.length > 0 &&
                        scheduledTickets.gates.map((obj) => {
                            return (
                                <Fragment>
                                    <h5>{localization.pendingTask}</h5>
                                    <div className="panel-card">
                                        <div className="panel-heading">
                                            Gate {obj.gate_no} - {obj.gate_type}
                                        </div>
                                        <div className="panel-body">
                                            <div className="form-group">
                                                <div className="details-listing faq-listing">
                                                    {obj.questions &&
                                                        obj.questions.length > 0 &&
                                                        obj.questions.map((ele) => {
                                                            return (
                                                                <div className="details-list ">
                                                                    <label className="data-title">
                                                                        {ele.questions}
                                                                    </label>
                                                                    {ele.answers.length &&
                                                                        ele.answers.map((el, ind) => {
                                                                            return (
                                                                                <div className="sub-question" key={ind}>
                                                                                    <label className="label">
                                                                                        {el.label}
                                                                                    </label>
                                                                                    <label className="label">
                                                                                        {el.answer}
                                                                                    </label>
                                                                                    <Link
                                                                                        to={`${baseUrl}/tickets/view-details/${ele.ticket_id}`}
                                                                                        className=" btn btn-transparent"
                                                                                    >
                                                                                        {localization.viewTicketDetails}
                                                                                    </Link>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            );
                        })}
                      {pmProjectChecklist && pmProjectChecklist?.happy_code_mail_pocs?.length>0 && (
                        <>
                        <div className="row mt-5">
                          <div className="col-md-12 col-xs-12">
                            <h4>{'Email POCs'}</h4>
                            <div className="d-flex justify-content-center">
                                <table className="table table-bordered w-100">
                                  <thead>
                                      <tr>
                                          <th>Name</th>
                                          <th>Email</th>
                                          <th>Contact Number</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {pmProjectChecklist?.happy_code_mail_pocs?.length > 0 ? (
                                          pmProjectChecklist.happy_code_mail_pocs.map((poc, index) => (
                                              <tr key={index}>
                                                  <td>{poc?.name || "N/A"}</td>
                                                  <td>{poc?.email || "N/A"}</td>
                                                  <td>{poc?.contact_no || "N/A"}</td>
                                              </tr>
                                          ))
                                      ) : (
                                          <tr>
                                              <td colSpan="3" className="text-center">
                                                  No POCs available
                                              </td>
                                          </tr>
                                      )}
                                  </tbody>
                              </table>
                          </div>
                          </div>
                        </div>
                        </>
                      )}
                      
                    <ModalPop
                        title={localization.conf}
                        show={isModal}
                        handleModalHide={handleModalHide}
                        keyboard
                        backdrop
                    >
                        <div className="text-center">
                            <div className="success">
                                <img src={Images?.tick} alt=""/>
                            </div>
                            <h5>{localization.assignedSuccessfully}</h5>
                            <Link to={() => window.location.reload()} className="btn btn-primary mb-4">
                                {localization.viewPmList} <img src={Images?.ArrowRight} alt=""/>
                            </Link>
                        </div>
                    </ModalPop>

                    <ModalPop
                        title={localization.note}
                        show={modalNote}
                        handleModalHide={() => {
                            setModalNote(false);
                        }}
                        keyboard
                        backdrop
                    >
                        <div className="text-center">
                            <h5>{localization.ChecklistNote}</h5>
                        </div>
                    </ModalPop>

                    <ModalPop
                        title={localization.enterOTP}
                        show={modalOtp}
                        handleModalHide={() => {
                          setModalOtp(false);
                        }}
                        keyboard
                        backdrop
                    >
                      <div className="text-center">
                      <div className="col-md-6 col-sm-12 col-xs-12">
                        <ConstantInput
                            label='Enter 6 digit OTP'
                            type="number"
                            max={6}
                            maxLength={6}
                            value={otp}
                            handleChange={(val) =>
                              setOtp(val)
                            }
                            required
                            isStarRequired={true}
                        />
                      </div>
                      <div className="text-center red mb-2">
                        {otpMsg}
                      </div>
                      <div className="text-center">
                        <a className={`resend-otp`} onClick={() => {resendOTP()}}>{'Send OTP'}</a>
                      </div>
                      <br />
                      <div className="text-center">
                        <a className='text-center btn btn-sm btn-primary' onClick={() => handlePmcomplete()}>{'Submit'}</a>
                      </div>
                      </div>
                    </ModalPop>

                    <ModalPop
                        title={localization.note}
                        show={isModalLocation}
                        handleModalHide={handleModalHideLocation}
                        keyboard
                        backdrop
                    >
                        <div className="text-center">
                            <h5 style={{color: 'red'}}>
                                {localization.locationApprovalPending}
                            </h5>
                        </div>
                    </ModalPop>

                    <ModalPop
                        title={localization.note}
                        show={isNotMatchModal}
                        handleModalHide={() => {
                            setNotMatchModal(false);
                        }}
                        keyboard
                        backdrop
                    >
                        <div className="text-center">
                            <h5 style={{color: 'red'}}>{localization.locationDoesNotMatch}</h5>
                        </div>
                    </ModalPop>

                    <ModalPop
                        title={localization.note}
                        show={isShowModal}
                        handleModalHide={() => {
                            setIsShowModal(false);
                        }}
                        keyboard
                        backdrop
                    >
                        <div className="text-center">
                            <h5 style={{color: 'red'}}>
                                {localization.locationApprovalRejected}
                            </h5>
                        </div>
                    </ModalPop>
                </>
            }
        </Layout>
    );
};
export default PmProjectSitesCheckList;
